<template>
  <iframe :src="fileURL"></iframe>
</template>
<script>
export default {
  name: "pdf-view",
  props: ["file"],
  data() {
    return {
      fileURL: ""
    };
  },
  methods: {
    setUrl() {
      this.fileURL = "/pdfjs/web/viewer.html?file=" + this.file;
      // this.fileURL = "/static/pdfjs/web/viewer.html?file=" + this.file;
    }
  },
  mounted: function() {
    this.setUrl();
  }
};
</script>
